const handler = require("./build/handler")

module.exports = Object.assign({}, handler)
